import { CloseCircleFilled, CloseOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { BetterEnum } from '@cims-online/shared'
import { CIMSClearButtonProps } from './types'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'

/**
 * # This component should only be used in custom form controls
 *
 * ---
 *
 * mimics the little clear button that shows up in Ant.D form inputs when the `allowClear`
 * prop is set.
 *
 * @see {@link CIMSClearButtonProps}
 */
const CIMSClearButton: React.FC<CIMSClearButtonProps> = ({
  onClick,
  children: _ignored,
  type = 'circle',
  fontSize = 12,
}) => {
  /**
   * yes. this is _super_ janky
   */
  const Color = {
    Default: '#00000040',
    Hover: '#00000073',
    Active: '#000000d9',
  } as const
  const [color, setColor] = useState<BetterEnum<typeof Color>>(Color.Default)
  const props: Pick<
    AntdIconProps,
    'style' | 'onClick' | 'onMouseEnter' | 'onMouseLeave'
  > = {
    style: { color, fontSize },
    onClick: (e) => {
      setColor(Color.Active)
      e.stopPropagation()
      onClick?.(e)
    },
    onMouseEnter: () => setColor(Color.Hover),
    onMouseLeave: () => setColor(Color.Default),
  }
  if (type === 'circle') return <CloseCircleFilled {...props} />
  else if (type === 'outlined') return <CloseOutlined {...props} />
  else return null
}

export default CIMSClearButton
